
// // // import React, { useState, useEffect } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import './Download.css';

// // // /**
// // //  * Download Landing Page Component - Modernized
// // //  * 
// // //  * Professional landing page for the On-Screen PWA with:
// // //  * - Clean, modern design without cartoonish elements
// // //  * - Professional icons and styling
// // //  * - Responsive design for all devices
// // //  * - PWA installation functionality
// // //  * 
// // //  * Color scheme:
// // //  * - Primary Orange: #ff6800
// // //  * - Primary Blue: #01057a
// // //  * - Gray: #3C3C3C
// // //  */
// // // function Download() {
// // //   const navigate = useNavigate();
  
// // //   // State for PWA installation
// // //   const [deferredPrompt, setDeferredPrompt] = useState(null);
// // //   const [isInstallable, setIsInstallable] = useState(false);
// // //   const [isInstalled, setIsInstalled] = useState(false);
// // //   const [platform, setPlatform] = useState('unknown');
// // //   const [showIOSInstructions, setShowIOSInstructions] = useState(false);
  
// // //   // Asset paths
// // //   const HERO_IMAGE = '/images/on-screen-logo.png';
// // //   const APP_ICON_192 = '/icon.png';
// // //   const SE3D_MARK = '/images/logo-xsm.png';
  
// // //   useEffect(() => {
// // //     detectPlatform();
// // //     checkIfInstalled();
    
// // //     const handleBeforeInstallPrompt = (e) => {
// // //       console.log('📱 PWA install prompt available');
// // //       e.preventDefault();
// // //       setDeferredPrompt(e);
// // //       setIsInstallable(true);
// // //     };
    
// // //     const handleAppInstalled = () => {
// // //       console.log('✅ PWA was installed');
// // //       setIsInstalled(true);
// // //       setIsInstallable(false);
// // //       setDeferredPrompt(null);
// // //     };
    
// // //     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
// // //     window.addEventListener('appinstalled', handleAppInstalled);
    
// // //     return () => {
// // //       window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
// // //       window.removeEventListener('appinstalled', handleAppInstalled);
// // //     };
// // //   }, []);
  
// // //   const detectPlatform = () => {
// // //     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
// // //     if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
// // //       setPlatform('ios');
// // //       return;
// // //     }
    
// // //     if (/android/i.test(userAgent)) {
// // //       setPlatform('android');
// // //       return;
// // //     }
    
// // //     if (!/Mobi|Android/i.test(userAgent)) {
// // //       setPlatform('desktop');
// // //       return;
// // //     }
    
// // //     setPlatform('unknown');
// // //   };
  
// // //   const checkIfInstalled = () => {
// // //     const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
// // //     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
// // //     const isIOSStandalone = window.navigator.standalone === true;
    
// // //     if (isStandalone || (isIOS && isIOSStandalone)) {
// // //       setIsInstalled(true);
// // //       console.log('✅ App is running as installed PWA');
// // //     }
// // //   };
  
// // //   const handleInstall = async () => {
// // //     if (!deferredPrompt) {
// // //       console.log('ℹ️ No install prompt available');
      
// // //       if (platform === 'ios') {
// // //         setShowIOSInstructions(true);
// // //       }
// // //       return;
// // //     }
    
// // //     try {
// // //       deferredPrompt.prompt();
// // //       const { outcome } = await deferredPrompt.userChoice;
      
// // //       console.log(`👤 User response to install prompt: ${outcome}`);
      
// // //       if (outcome === 'accepted') {
// // //         console.log('✅ User accepted the install prompt');
// // //         setIsInstalled(true);
// // //       } else {
// // //         console.log('❌ User dismissed the install prompt');
// // //       }
      
// // //       setDeferredPrompt(null);
// // //       setIsInstallable(false);
      
// // //     } catch (error) {
// // //       console.error('❌ Error during PWA installation:', error);
// // //     }
// // //   };
  
// // //   const handleGetStarted = () => {
// // //     navigate('/login');
// // //   };
  
// // //   const handleOwnerSignup = () => {
// // //     navigate('/owneradd');
// // //   };
  
// // //   const scrollToInstall = () => {
// // //     document.getElementById('install-section')?.scrollIntoView({ 
// // //       behavior: 'smooth',
// // //       block: 'center'
// // //     });
// // //   };
  
// // //   const renderInstallInstructions = () => {
// // //     if (isInstalled) {
// // //       return (
// // //         <div className="install-status installed">
// // //           <div className="status-icon-wrapper">
// // //             <svg className="status-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
// // //             </svg>
// // //           </div>
// // //           <h3>App Installed Successfully!</h3>
// // //           <p>You can now access On-Screen from your home screen.</p>
// // //           <button className="btn btn-primary" onClick={handleGetStarted}>
// // //             Get Started
// // //           </button>
// // //         </div>
// // //       );
// // //     }
    
// // //     if (isInstallable && platform !== 'ios') {
// // //       return (
// // //         <div className="install-actions">
// // //           <button className="btn btn-install" onClick={handleInstall}>
// // //             <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
// // //             </svg>
// // //             Install App
// // //           </button>
// // //           <button className="btn btn-secondary" onClick={handleGetStarted}>
// // //             Continue in Browser
// // //           </button>
// // //         </div>
// // //       );
// // //     }
    
// // //     if (platform === 'ios') {
// // //       return (
// // //         <div className="install-instructions">
// // //           <button 
// // //             className="btn btn-install" 
// // //             onClick={() => setShowIOSInstructions(!showIOSInstructions)}
// // //           >
// // //             <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
// // //             </svg>
// // //             Install on iOS
// // //           </button>
          
// // //           {showIOSInstructions && (
// // //             <div className="ios-instructions">
// // //               <h4>To install On-Screen on iOS:</h4>
// // //               <ol>
// // //                 <li>Tap the <strong>Share</strong> button in Safari</li>
// // //                 <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
// // //                 <li>Tap <strong>"Add"</strong> in the top right</li>
// // //                 <li>Find the On-Screen icon on your home screen</li>
// // //               </ol>
// // //             </div>
// // //           )}
          
// // //           <button className="btn btn-secondary" onClick={handleGetStarted}>
// // //             Continue in Browser
// // //           </button>
// // //         </div>
// // //       );
// // //     }
    
// // //     return (
// // //       <div className="install-instructions">
// // //         <div className="install-note">
// // //           To install this app, look for the "Install" option in your browser menu.
// // //         </div>
// // //         <button className="btn btn-primary" onClick={handleGetStarted}>
// // //           Continue in Browser
// // //         </button>
// // //       </div>
// // //     );
// // //   };
  
// // //   // User guides with professional icons
// // //   const userGuides = [
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
// // //         </svg>
// // //       ),
// // //       title: 'Create an Account',
// // //       description: 'Sign up as an owner to create your tenant and start using On-Screen',
// // //       action: 'route',
// // //       to: '/owneradd',
// // //       href: '/owneradd',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
// // //         </svg>
// // //       ),
// // //       title: 'Sign In',
// // //       description: 'Log in to access your tenant and start scheduling posts and managing events',
// // //       action: 'route',
// // //       to: '/login',
// // //       href: '/login',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
// // //         </svg>
// // //       ),
// // //       title: 'Install the App',
// // //       description: 'Install On-Screen to your home screen for the best experience',
// // //       action: 'install',
// // //       href: '#install-section',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
// // //         </svg>
// // //       ),
// // //       title: 'Terms of Use',
// // //       description: 'Review product terms and usage policies',
// // //       action: 'route',
// // //       to: '/termsofuse',
// // //       href: '/termsofuse',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
// // //         </svg>
// // //       ),
// // //       title: 'Privacy Policy',
// // //       description: 'Learn how your data is handled and protected',
// // //       action: 'route',
// // //       to: '/privacypolicy',
// // //       href: '/privacypolicy',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
// // //         </svg>
// // //       ),
// // //       title: 'Contact Support',
// // //       description: 'Need help? Send us a message and we\'ll get back to you',
// // //       action: 'route',
// // //       to: '/sendemail',
// // //       href: '/sendemail',
// // //     },
// // //   ];

// // //   // Features with professional icons
// // //   const features = [
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
// // //         </svg>
// // //       ),
// // //       title: 'Multi-Platform Support',
// // //       description: 'Connect and manage supported social platforms from one place (tenant-based accounts)',
// // //       status: 'available',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
// // //         </svg>
// // //       ),
// // //       title: 'Smart Scheduling',
// // //       description: 'Schedule posts in advance and manage your publishing workflow',
// // //       status: 'available',
// // //     },
// // //     {
// // //       icon: (
// // //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
// // //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
// // //         </svg>
// // //       ),
// // //       title: 'Event Management',
// // //       description: 'Create events with auctions, raffles, and event items (with media uploads)',
// // //       status: 'available',
// // //     },
// // //     // {
// // //     //   icon: (
// // //     //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //     //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
// // //     //     </svg>
// // //     //   ),
// // //     //   title: 'Analytics & Insights',
// // //     //   description: 'Performance dashboards and engagement insights (planned feature)',
// // //     //   status: 'comingSoon',
// // //     // },
// // //     // {
// // //     //   icon: (
// // //     //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //     //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
// // //     //     </svg>
// // //     //   ),
// // //     //   title: 'Built-in Media Editor',
// // //     //   description: 'In-app image/video editing tools (planned feature)',
// // //     //   status: 'comingSoon',
// // //     // },
// // //     // {
// // //     //   icon: (
// // //     //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //     //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
// // //     //     </svg>
// // //     //   ),
// // //     //   title: 'Push Notifications',
// // //     //   description: 'Real-time notifications for updates and activity (planned feature)',
// // //     //   status: 'comingSoon',
// // //     // },
// // //   ];

// // //   const handleGuideClick = (e, guide) => {
// // //     e.preventDefault();

// // //     if (guide.action === 'install') {
// // //       scrollToInstall();
// // //       return;
// // //     }

// // //     if (guide.action === 'route' && guide.to) {
// // //       navigate(guide.to);
// // //     }
// // //   };

// // //   return (
// // //     <div className="download-page">
// // //       {/* Hero Section */}
// // //       <section className="hero-section">
// // //         <div className="container">
// // //           <div className="hero-content">
// // //             <div className="hero-text">
// // //               <h1 className="hero-title">
// // //                 <span className="brand-name">On-Screen</span>
// // //                 <span className="hero-subtitle">Social Media Management, Simplified</span>
// // //               </h1>
// // //               <p className="hero-description">
// // //                 The all-in-one platform for scheduling posts, managing events,
// // //                 and growing your social media presence across multiple platforms.
// // //               </p>

// // //               {/* Installation Section */}
// // //               <div id="install-section" className="install-section">
// // //                 {renderInstallInstructions()}
// // //               </div>

// // //               {/* Additional CTA for new users */}
// // //               <div className="cta-secondary">
// // //                 <p className="cta-text">Don't have an account yet?</p>
// // //                 <button className="btn btn-outline" onClick={handleOwnerSignup}>
// // //                   Sign Up Free
// // //                 </button>
// // //               </div>
// // //             </div>

// // //             {/* Hero Image/Logo */}
// // //             <div className="hero-image">
// // //               <div className="app-preview">
// // //                 <img
// // //                   className="download-hero-logo"
// // //                   src={HERO_IMAGE}
// // //                   alt="On-Screen"
// // //                   loading="eager"
// // //                 />
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Features Section */}
// // //       <section className="features-section">
// // //         <div className="container">
// // //           <h2 className="section-title">Features</h2>
// // //           <p className="section-description">
// // //             What's available today (and what's coming next)
// // //           </p>

// // //           <div className="features-grid">
// // //             {features.map((feature, index) => {
// // //               const isSoon = feature.status === 'comingSoon';
// // //               return (
// // //                 <div
// // //                   key={index}
// // //                   className={`feature-card ${isSoon ? 'coming-soon' : ''}`}
// // //                 >
// // //                   {isSoon && (
// // //                     <div className="feature-badge feature-badge-soon">Coming Soon</div>
// // //                   )}

// // //                   <div className="feature-icon-wrapper">
// // //                     {feature.icon}
// // //                   </div>
// // //                   <h3 className="feature-title">{feature.title}</h3>
// // //                   <p className="feature-description">{feature.description}</p>
// // //                 </div>
// // //               );
// // //             })}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Quick Links / Guides Section */}
// // //       <section className="guides-section">
// // //         <div className="container">
// // //           <h2 className="section-title">Getting Started</h2>
// // //           <p className="section-description">
// // //             Quick links to help you install the app and access key pages
// // //           </p>

// // //           <div className="guides-grid">
// // //             {userGuides.map((guide, index) => (
// // //               <a
// // //                 key={index}
// // //                 href={guide.href}
// // //                 className="guide-card"
// // //                 onClick={(e) => handleGuideClick(e, guide)}
// // //               >
// // //                 <div className="guide-icon-wrapper">
// // //                   {guide.icon}
// // //                 </div>
// // //                 <div className="guide-content">
// // //                   <h3 className="guide-title">{guide.title}</h3>
// // //                   <p className="guide-description">{guide.description}</p>
// // //                 </div>
// // //                 <div className="guide-arrow">
// // //                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
// // //                   </svg>
// // //                 </div>
// // //               </a>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* CTA Section */}
// // //       <section className="cta-section">
// // //         <div className="container">
// // //           <div className="cta-content">
// // //             <h2 className="cta-title">Ready to Get Started?</h2>
// // //             <p className="cta-description">
// // //               Join thousands of users managing their social media presence with On-Screen
// // //             </p>
// // //             <div className="cta-buttons">
// // //               {!isInstalled && isInstallable && (
// // //                 <button className="btn btn-install-large" onClick={handleInstall}>
// // //                   <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
// // //                   </svg>
// // //                   Install App Now
// // //                 </button>
// // //               )}
// // //               {!isInstalled && platform === 'ios' && (
// // //                 <button
// // //                   className="btn btn-install-large"
// // //                   onClick={() => setShowIOSInstructions(true)}
// // //                 >
// // //                   <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// // //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
// // //                   </svg>
// // //                   Install on iOS
// // //                 </button>
// // //               )}
// // //               <button className="btn btn-primary-large" onClick={handleGetStarted}>
// // //                 Launch App
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>
      
// // //       <footer className="download-footer">
// // //         <div className="container">
// // //           <div className="footer-content">
// // //             <p className="footer-text">
// // //               © 2025 On-Screen. All rights reserved.
// // //             </p>
// // //             <div className="se3d-footer">
// // //               <img className="se3d-mark" src={SE3D_MARK} alt="SE3D Inc." loading="lazy" />
// // //               <div className="se3d-text">
// // //                 <div className="se3d-line-1">SE3D Inc.</div>
// // //               </div>
// // //             </div>

// // //             <div className="footer-links">
// // //               <a href="/termsofuse" className="footer-link">Terms</a>
// // //               <a href="/privacypolicy" className="footer-link">Privacy</a>
// // //               <a href="/sendemail" className="footer-link">Support</a>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </footer>
// // //     </div>
// // //   );
// // // }

// // // export default Download;


// // import React, { useState, useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import './Download.css';

// // /**
// //  * Download Landing Page Component - Modern Redesign
// //  * 
// //  * Dribbble-inspired landing page with:
// //  * - Bold, modern typography
// //  * - Vibrant gradient backgrounds
// //  * - Clean card layouts
// //  * - Professional animations
// //  * - Clear call-to-actions
// //  * 
// //  * Color scheme:
// //  * - Primary Orange: #ff6800
// //  * - Primary Blue: #01057a
// //  * - Gray: #3C3C3C
// //  */
// // function Download() {
// //   const navigate = useNavigate();
  
// //   // State for PWA installation
// //   const [deferredPrompt, setDeferredPrompt] = useState(null);
// //   const [isInstallable, setIsInstallable] = useState(false);
// //   const [isInstalled, setIsInstalled] = useState(false);
// //   const [platform, setPlatform] = useState('unknown');
// //   const [showIOSInstructions, setShowIOSInstructions] = useState(false);
  
// //   // Asset paths
// //   const HERO_IMAGE = '/images/onscreen.png';
// //   const APP_ICON_192 = '/icon.png';
// //   const SE3D_MARK = '/images/SED3.png';
  
// //   useEffect(() => {
// //     detectPlatform();
// //     checkIfInstalled();
    
// //     const handleBeforeInstallPrompt = (e) => {
// //       console.log('📱 PWA install prompt available');
// //       e.preventDefault();
// //       setDeferredPrompt(e);
// //       setIsInstallable(true);
// //     };
    
// //     const handleAppInstalled = () => {
// //       console.log('✅ PWA was installed');
// //       setIsInstalled(true);
// //       setIsInstallable(false);
// //       setDeferredPrompt(null);
// //     };
    
// //     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
// //     window.addEventListener('appinstalled', handleAppInstalled);
    
// //     return () => {
// //       window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
// //       window.removeEventListener('appinstalled', handleAppInstalled);
// //     };
// //   }, []);
  
// //   const detectPlatform = () => {
// //     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
// //     if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
// //       setPlatform('ios');
// //       return;
// //     }
    
// //     if (/android/i.test(userAgent)) {
// //       setPlatform('android');
// //       return;
// //     }
    
// //     if (!/Mobi|Android/i.test(userAgent)) {
// //       setPlatform('desktop');
// //       return;
// //     }
    
// //     setPlatform('unknown');
// //   };
  
// //   const checkIfInstalled = () => {
// //     const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
// //     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
// //     const isIOSStandalone = window.navigator.standalone === true;
    
// //     if (isStandalone || (isIOS && isIOSStandalone)) {
// //       setIsInstalled(true);
// //       console.log('✅ App is running as installed PWA');
// //     }
// //   };
  
// //   const handleInstall = async () => {
// //     if (!deferredPrompt) {
// //       console.log('ℹ️ No install prompt available');
      
// //       if (platform === 'ios') {
// //         setShowIOSInstructions(true);
// //       }
// //       return;
// //     }
    
// //     try {
// //       deferredPrompt.prompt();
// //       const { outcome } = await deferredPrompt.userChoice;
      
// //       console.log(`👤 User response to install prompt: ${outcome}`);
      
// //       if (outcome === 'accepted') {
// //         console.log('✅ User accepted the install prompt');
// //         setIsInstalled(true);
// //       } else {
// //         console.log('❌ User dismissed the install prompt');
// //       }
      
// //       setDeferredPrompt(null);
// //       setIsInstallable(false);
      
// //     } catch (error) {
// //       console.error('❌ Error during PWA installation:', error);
// //     }
// //   };
  
// //   const handleGetStarted = () => {
// //     navigate('/login');
// //   };
  
// //   const handleOwnerSignup = () => {
// //     navigate('/owneradd');
// //   };
  
// //   const scrollToInstall = () => {
// //     document.getElementById('install-section')?.scrollIntoView({ 
// //       behavior: 'smooth',
// //       block: 'center'
// //     });
// //   };
  
// //   const renderInstallInstructions = () => {
// //     if (isInstalled) {
// //       return (
// //         <div className="install-card success">
// //           <div className="install-icon-wrapper success">
// //             <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
// //             </svg>
// //           </div>
// //           <h3>You're All Set! 🎉</h3>
// //           <p>On-Screen is installed and ready to use.</p>
// //           <button className="cta-button primary" onClick={handleGetStarted}>
// //             Launch App
// //           </button>
// //         </div>
// //       );
// //     }
    
// //     if (isInstallable && platform !== 'ios') {
// //       return (
// //         <div className="install-card">
// //           <div className="install-icon-wrapper">
// //             <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
// //             </svg>
// //           </div>
// //           <h3>Install On-Screen</h3>
// //           <p>Get the best experience with our PWA</p>
// //           <button className="cta-button primary" onClick={handleInstall}>
// //             Install Now
// //           </button>
// //           <button className="cta-button secondary" onClick={handleGetStarted}>
// //             Continue in Browser
// //           </button>
// //         </div>
// //       );
// //     }
    
// //     if (platform === 'ios') {
// //       return (
// //         <div className="install-card">
// //           <div className="install-icon-wrapper">
// //             <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
// //             </svg>
// //           </div>
// //           <h3>Install on iOS</h3>
// //           <button 
// //             className="cta-button primary" 
// //             onClick={() => setShowIOSInstructions(!showIOSInstructions)}
// //           >
// //             View Instructions
// //           </button>
          
// //           {showIOSInstructions && (
// //             <div className="ios-instructions">
// //               <ol>
// //                 <li>Tap the <strong>Share</strong> button in Safari</li>
// //                 <li>Scroll and tap <strong>"Add to Home Screen"</strong></li>
// //                 <li>Tap <strong>"Add"</strong></li>
// //               </ol>
// //             </div>
// //           )}
          
// //           <button className="cta-button secondary" onClick={handleGetStarted}>
// //             Continue in Browser
// //           </button>
// //         </div>
// //       );
// //     }
    
// //     return (
// //       <div className="install-card">
// //         <div className="install-icon-wrapper">
// //           <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
// //           </svg>
// //         </div>
// //         <h3>Get Started</h3>
// //         <p>Look for "Install" in your browser menu</p>
// //         <button className="cta-button primary" onClick={handleGetStarted}>
// //           Continue in Browser
// //         </button>
// //       </div>
// //     );
// //   };

// //   // Features with professional icons
// //   const features = [
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
// //         </svg>
// //       ),
// //       title: 'Smart Scheduling',
// //       description: 'Plan and schedule your content across all platforms with our intuitive calendar',
// //       color: 'orange'
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
// //         </svg>
// //       ),
// //       title: 'Event Management',
// //       description: 'Create and manage events, auctions, and raffles with ease',
// //       color: 'blue'
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
// //         </svg>
// //       ),
// //       title: 'Multi-Platform',
// //       description: 'Connect Instagram, Facebook, Twitter, LinkedIn, TikTok, YouTube & more',
// //       color: 'orange'
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
// //         </svg>
// //       ),
// //       title: 'Analytics',
// //       description: 'Track performance and engagement with detailed insights (coming soon)',
// //       color: 'blue'
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
// //         </svg>
// //       ),
// //       title: 'Media Editor',
// //       description: 'Edit images and videos right in the app (coming soon)',
// //       color: 'orange'
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
// //         </svg>
// //       ),
// //       title: 'Notifications',
// //       description: 'Stay updated with real-time push notifications (coming soon)',
// //       color: 'blue'
// //     },
// //   ];

// //   // Quick links with icons
// //   const quickLinks = [
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
// //         </svg>
// //       ),
// //       title: 'Create Account',
// //       description: 'Sign up and create your tenant',
// //       action: () => navigate('/owneradd'),
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
// //         </svg>
// //       ),
// //       title: 'Sign In',
// //       description: 'Access your account',
// //       action: () => navigate('/login'),
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
// //         </svg>
// //       ),
// //       title: 'Documentation',
// //       description: 'Learn how to use On-Screen',
// //       action: () => window.open('https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g', '_blank'),
// //     },
// //     {
// //       icon: (
// //         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
// //         </svg>
// //       ),
// //       title: 'Install App',
// //       description: 'Get the PWA experience',
// //       action: scrollToInstall,
// //     },
// //   ];

// //   return (
// //     <div className="download-page modern">
// //       {/* Hero Section */}
// //       <section className="hero-modern">
// //         <div className="hero-gradient"></div>
// //         <div className="hero-pattern"></div>
        
// //         <div className="container">
// //           <div className="hero-content-modern">
// //             <div className="hero-text-modern">
// //               <div className="badge">Social Media Management</div>
// //               <h1 className="hero-title-modern">
// //                 Simplify Your <span className="gradient-text">Social Media</span> Workflow
// //               </h1>
// //               <p className="hero-description-modern">
// //                 Schedule posts, manage events, and grow your presence across all platforms. 
// //                 One powerful app for all your social media needs.
// //               </p>
              
// //               <div className="hero-cta-buttons">
// //                 <button className="cta-button primary large" onClick={handleGetStarted}>
// //                   Get Started Free
// //                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
// //                   </svg>
// //                 </button>
// //                 <button className="cta-button secondary large" onClick={() => window.open('https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g', '_blank')}>
// //                   View Documentation
// //                 </button>
// //               </div>
              
// //               <div className="social-proof">
// //                 <div className="proof-item">
// //                   <div className="proof-number">1000+</div>
// //                   <div className="proof-label">Active Users</div>
// //                 </div>
// //                 <div className="proof-divider"></div>
// //                 <div className="proof-item">
// //                   <div className="proof-number">7</div>
// //                   <div className="proof-label">Platforms</div>
// //                 </div>
// //                 <div className="proof-divider"></div>
// //                 <div className="proof-item">
// //                   <div className="proof-number">99%</div>
// //                   <div className="proof-label">Uptime</div>
// //                 </div>
// //               </div>
// //             </div>
            
// //             <div className="hero-visual">
// //               <div className="visual-card floating">
// //                 <img src={HERO_IMAGE} alt="On-Screen" className="hero-logo-modern" />
// //               </div>
// //               <div className="floating-element el-1"></div>
// //               <div className="floating-element el-2"></div>
// //               <div className="floating-element el-3"></div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Install Section */}
// //       <section className="install-section-modern" id="install-section">
// //         <div className="container">
// //           <div className="install-content">
// //             {renderInstallInstructions()}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Features Section */}
// //       <section className="features-modern">
// //         <div className="container">
// //           <div className="section-header">
// //             <div className="badge">Features</div>
// //             <h2 className="section-title-modern">Everything You Need</h2>
// //             <p className="section-description-modern">
// //               Powerful tools to manage your social media presence efficiently
// //             </p>
// //           </div>
          
// //           <div className="features-grid-modern">
// //             {features.map((feature, index) => (
// //               <div key={index} className={`feature-card-modern ${feature.color}`}>
// //                 <div className="feature-icon-modern">
// //                   {feature.icon}
// //                 </div>
// //                 <h3 className="feature-title-modern">{feature.title}</h3>
// //                 <p className="feature-description-modern">{feature.description}</p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Quick Links Section */}
// //       <section className="quick-links-modern">
// //         <div className="container">
// //           <div className="section-header">
// //             <div className="badge">Get Started</div>
// //             <h2 className="section-title-modern">Quick Access</h2>
// //             <p className="section-description-modern">
// //               Everything you need to get up and running
// //             </p>
// //           </div>
          
// //           <div className="quick-links-grid">
// //             {quickLinks.map((link, index) => (
// //               <button
// //                 key={index}
// //                 className="quick-link-card"
// //                 onClick={link.action}
// //               >
// //                 <div className="quick-link-icon">
// //                   {link.icon}
// //                 </div>
// //                 <h3 className="quick-link-title">{link.title}</h3>
// //                 <p className="quick-link-description">{link.description}</p>
// //                 <div className="quick-link-arrow">
// //                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
// //                   </svg>
// //                 </div>
// //               </button>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA Section */}
// //       <section className="cta-modern">
// //         <div className="cta-gradient"></div>
// //         <div className="container">
// //           <div className="cta-content-modern">
// //             <h2 className="cta-title-modern">Ready to Transform Your Social Media?</h2>
// //             <p className="cta-description-modern">
// //               Join thousands of users who are already managing their social media presence with On-Screen
// //             </p>
// //             <div className="cta-buttons-modern">
// //               {!isInstalled && isInstallable && (
// //                 <button className="cta-button primary large" onClick={handleInstall}>
// //                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
// //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
// //                   </svg>
// //                   Install App
// //                 </button>
// //               )}
// //               <button className="cta-button primary large" onClick={handleOwnerSignup}>
// //                 Sign Up Free
// //               </button>
// //               <button className="cta-button secondary large" onClick={handleGetStarted}>
// //                 Sign In
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Footer */}
// //       <footer className="footer-modern">
// //         <div className="container">
// //           <div className="footer-content-modern">
// //             <div className="footer-brand">
// //               <img src={HERO_IMAGE} alt="On-Screen" className="footer-logo" />
// //               <p className="footer-tagline">Social Media Management, Simplified</p>
// //             </div>
            
// //             <div className="footer-links-modern">
// //               <div className="footer-column">
// //                 <h4>Product</h4>
// //                 <a href="/login">Sign In</a>
// //                 <a href="/owneradd">Sign Up</a>
// //                 <a href="https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g" target="_blank" rel="noopener noreferrer">Documentation</a>
// //               </div>
              
// //               <div className="footer-column">
// //                 <h4>Legal</h4>
// //                 <a href="/termsofuse">Terms of Use</a>
// //                 <a href="/privacypolicy">Privacy Policy</a>
// //               </div>
              
// //               <div className="footer-column">
// //                 <h4>Support</h4>
// //                 <a href="/sendemail">Contact Us</a>
// //               </div>
// //             </div>
            
// //             <div className="footer-company">
// //               <img src={SE3D_MARK} alt="SE3D Inc." className="company-logo" />
// //               <div className="company-text">
// //                 <div className="company-name">SE3D Inc.</div>
// //                 <div className="company-tagline">Building the future of social media management</div>
// //               </div>
// //             </div>
// //           </div>
          
// //           <div className="footer-bottom">
// //             <p>© 2025 On-Screen. All rights reserved.</p>
// //           </div>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // }

// // export default Download;



// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './Download.css';

// /**
//  * Download Landing Page Component - Modern Redesign
//  * 
//  * Dribbble-inspired landing page with:
//  * - Bold, modern typography
//  * - Vibrant gradient backgrounds
//  * - Clean card layouts
//  * - Professional animations
//  * - Clear call-to-actions
//  * 
//  * Color scheme:
//  * - Primary Orange: #ff6800
//  * - Primary Blue: #01057a
//  * - Gray: #3C3C3C
//  */
// function Download() {
//   const navigate = useNavigate();
  
//   // State for PWA installation
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [isInstallable, setIsInstallable] = useState(false);
//   const [isInstalled, setIsInstalled] = useState(false);
//   const [platform, setPlatform] = useState('unknown');
//   const [showIOSInstructions, setShowIOSInstructions] = useState(false);
  
//   // Asset paths
//   const HERO_IMAGE = '/images/on-screen-logo.png';
//   const APP_ICON_192 = '/on-screen-logo-192x192.png';
//   const SE3D_MARK = '/images/logo-xsm.png';
  
//   useEffect(() => {
//     detectPlatform();
//     checkIfInstalled();
    
//     const handleBeforeInstallPrompt = (e) => {
//       console.log('📱 PWA install prompt available');
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setIsInstallable(true);
//     };
    
//     const handleAppInstalled = () => {
//       console.log('✅ PWA was installed');
//       setIsInstalled(true);
//       setIsInstallable(false);
//       setDeferredPrompt(null);
//     };
    
//     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//     window.addEventListener('appinstalled', handleAppInstalled);
    
//     return () => {
//       window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//       window.removeEventListener('appinstalled', handleAppInstalled);
//     };
//   }, []);
  
//   const detectPlatform = () => {
//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
//     if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
//       setPlatform('ios');
//       return;
//     }
    
//     if (/android/i.test(userAgent)) {
//       setPlatform('android');
//       return;
//     }
    
//     if (!/Mobi|Android/i.test(userAgent)) {
//       setPlatform('desktop');
//       return;
//     }
    
//     setPlatform('unknown');
//   };
  
//   const checkIfInstalled = () => {
//     const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
//     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
//     const isIOSStandalone = window.navigator.standalone === true;
    
//     if (isStandalone || (isIOS && isIOSStandalone)) {
//       setIsInstalled(true);
//       console.log('✅ App is running as installed PWA');
//     }
//   };
  
//   const handleInstall = async () => {
//     if (!deferredPrompt) {
//       console.log('ℹ️ No install prompt available');
      
//       if (platform === 'ios') {
//         setShowIOSInstructions(true);
//       }
//       return;
//     }
    
//     try {
//       deferredPrompt.prompt();
//       const { outcome } = await deferredPrompt.userChoice;
      
//       console.log(`👤 User response to install prompt: ${outcome}`);
      
//       if (outcome === 'accepted') {
//         console.log('✅ User accepted the install prompt');
//         setIsInstalled(true);
//       } else {
//         console.log('❌ User dismissed the install prompt');
//       }
      
//       setDeferredPrompt(null);
//       setIsInstallable(false);
      
//     } catch (error) {
//       console.error('❌ Error during PWA installation:', error);
//     }
//   };
  
//   const handleGetStarted = () => {
//     navigate('/login');
//   };
  
//   const handleOwnerSignup = () => {
//     navigate('/owneradd');
//   };
  
//   const scrollToInstall = () => {
//     document.getElementById('install-section')?.scrollIntoView({ 
//       behavior: 'smooth',
//       block: 'center'
//     });
//   };
  
//   const renderInstallInstructions = () => {
//     if (isInstalled) {
//       return (
//         <div className="install-card success">
//           <div className="install-icon-wrapper success">
//             <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
//             </svg>
//           </div>
//           <h3>You're All Set! 🎉</h3>
//           <p>On-Screen is installed and ready to use.</p>
//           <button className="cta-button primary" onClick={handleGetStarted}>
//             Launch App
//           </button>
//         </div>
//       );
//     }
    
//     if (isInstallable && platform !== 'ios') {
//       return (
//         <div className="install-card">
//           <div className="install-icon-wrapper">
//             <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//             </svg>
//           </div>
//           <h3>Install On-Screen</h3>
//           <p>Get the best experience with our PWA</p>
//           <button className="cta-button primary" onClick={handleInstall}>
//             Install Now
//           </button>
//           <button className="cta-button secondary" onClick={handleGetStarted}>
//             Continue in Browser
//           </button>
//         </div>
//       );
//     }
    
//     if (platform === 'ios') {
//       return (
//         <div className="install-card">
//           <div className="install-icon-wrapper">
//             <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
//             </svg>
//           </div>
//           <h3>Install on iOS</h3>
//           <button 
//             className="cta-button primary" 
//             onClick={() => setShowIOSInstructions(!showIOSInstructions)}
//           >
//             View Instructions
//           </button>
          
//           {showIOSInstructions && (
//             <div className="ios-instructions">
//               <ol>
//                 <li>Tap the <strong>Share</strong> button in Safari</li>
//                 <li>Scroll and tap <strong>"Add to Home Screen"</strong></li>
//                 <li>Tap <strong>"Add"</strong></li>
//               </ol>
//             </div>
//           )}
          
//           <button className="cta-button secondary" onClick={handleGetStarted}>
//             Continue in Browser
//           </button>
//         </div>
//       );
//     }
    
//     return (
//       <div className="install-card">
//         <div className="install-icon-wrapper">
//           <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
//           </svg>
//         </div>
//         <h3>Get Started</h3>
//         <p>Look for "Install" in your browser menu</p>
//         <button className="cta-button primary" onClick={handleGetStarted}>
//           Continue in Browser
//         </button>
//       </div>
//     );
//   };

//   // Features with professional icons
//   const features = [
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//         </svg>
//       ),
//       title: 'Smart Scheduling',
//       description: 'Plan and schedule your content across all platforms with our intuitive calendar',
//       color: 'orange'
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
//         </svg>
//       ),
//       title: 'Event Management',
//       description: 'Create and manage events, auctions, and raffles with ease',
//       color: 'blue'
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
//         </svg>
//       ),
//       title: 'Multi-Platform',
//       description: 'Connect Instagram, Facebook, Twitter, LinkedIn, TikTok, YouTube & more',
//       color: 'orange'
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//         </svg>
//       ),
//       title: 'Analytics',
//       description: 'Track performance and engagement with detailed insights (coming soon)',
//       color: 'blue'
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//         </svg>
//       ),
//       title: 'Media Editor',
//       description: 'Edit images and videos right in the app (coming soon)',
//       color: 'orange'
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
//         </svg>
//       ),
//       title: 'Notifications',
//       description: 'Stay updated with real-time push notifications (coming soon)',
//       color: 'blue'
//     },
//   ];

//   // Quick links with icons
//   const quickLinks = [
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
//         </svg>
//       ),
//       title: 'Create Account',
//       description: 'Sign up and create your tenant',
//       action: () => navigate('/owneradd'),
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
//         </svg>
//       ),
//       title: 'Sign In',
//       description: 'Access your account',
//       action: () => navigate('/login'),
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//         </svg>
//       ),
//       title: 'Documentation',
//       description: 'Learn how to use On-Screen',
//       action: () => window.open('https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g', '_blank'),
//     },
//     {
//       icon: (
//         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
//         </svg>
//       ),
//       title: 'Install App',
//       description: 'Get the PWA experience',
//       action: scrollToInstall,
//     },
//   ];

//   return (
//     <div className="download-page modern">
//       {/* Hero Section */}
//       <section className="hero-modern">
//         <div className="hero-gradient"></div>
//         <div className="hero-pattern"></div>
        
//         <div className="container">
//           <div className="hero-content-modern">
//             <div className="hero-text-modern">
//               <div className="badge">Social Media Management</div>
//               <h1 className="hero-title-modern">
//                 Simplify Your <span className="gradient-text">Social Media</span> Workflow
//               </h1>
//               <p className="hero-description-modern">
//                 Schedule posts, manage events, and grow your presence across all platforms. 
//                 One powerful app for all your social media needs.
//               </p>
              
//               <div className="hero-cta-buttons">
//                 <button className="cta-button primary large" onClick={handleGetStarted}>
//                   Get Started Free
//                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
//                   </svg>
//                 </button>
//                 <button className="cta-button secondary large" onClick={() => window.open('https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g', '_blank')}>
//                   View Documentation
//                 </button>
//               </div>
              
//               <div className="social-proof">
//                 <div className="proof-item">
//                   <div className="proof-number">1000+</div>
//                   <div className="proof-label">Active Users</div>
//                 </div>
//                 <div className="proof-divider"></div>
//                 <div className="proof-item">
//                   <div className="proof-number">7</div>
//                   <div className="proof-label">Platforms</div>
//                 </div>
//                 <div className="proof-divider"></div>
//                 <div className="proof-item">
//                   <div className="proof-number">99%</div>
//                   <div className="proof-label">Uptime</div>
//                 </div>
//               </div>
//             </div>
            
//             <div className="hero-visual">
//               <div className="visual-card floating">
//                 <img src={HERO_IMAGE} alt="On-Screen" className="hero-logo-modern" />
//               </div>
//               <div className="floating-element el-1"></div>
//               <div className="floating-element el-2"></div>
//               <div className="floating-element el-3"></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Install Section */}
//       <section className="install-section-modern" id="install-section">
//         <div className="container">
//           <div className="install-content">
//             {renderInstallInstructions()}
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
//       <section className="features-modern">
//         <div className="container">
//           <div className="section-header">
//             <div className="badge">Features</div>
//             <h2 className="section-title-modern">Everything You Need</h2>
//             <p className="section-description-modern">
//               Powerful tools to manage your social media presence efficiently
//             </p>
//           </div>
          
//           <div className="features-grid-modern">
//             {features.map((feature, index) => (
//               <div key={index} className={`feature-card-modern ${feature.color}`}>
//                 <div className="feature-icon-modern">
//                   {feature.icon}
//                 </div>
//                 <h3 className="feature-title-modern">{feature.title}</h3>
//                 <p className="feature-description-modern">{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Quick Links Section */}
//       <section className="quick-links-modern">
//         <div className="container">
//           <div className="section-header">
//             <div className="badge">Get Started</div>
//             <h2 className="section-title-modern">Quick Access</h2>
//             <p className="section-description-modern">
//               Everything you need to get up and running
//             </p>
//           </div>
          
//           <div className="quick-links-grid">
//             {quickLinks.map((link, index) => (
//               <button
//                 key={index}
//                 className="quick-link-card"
//                 onClick={link.action}
//               >
//                 <div className="quick-link-icon">
//                   {link.icon}
//                 </div>
//                 <h3 className="quick-link-title">{link.title}</h3>
//                 <p className="quick-link-description">{link.description}</p>
//                 <div className="quick-link-arrow">
//                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                   </svg>
//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="cta-modern">
//         <div className="cta-gradient"></div>
//         <div className="container">
//           <div className="cta-content-modern">
//             <h2 className="cta-title-modern">Ready to Transform Your Social Media?</h2>
//             <p className="cta-description-modern">
//               Join thousands of users who are already managing their social media presence with On-Screen
//             </p>
//             <div className="cta-buttons-modern">
//               {!isInstalled && isInstallable && (
//                 <button className="cta-button primary large" onClick={handleInstall}>
//                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                   </svg>
//                   Install App
//                 </button>
//               )}
//               <button className="cta-button primary large" onClick={handleOwnerSignup}>
//                 Sign Up Free
//               </button>
//               <button className="cta-button secondary large" onClick={handleGetStarted}>
//                 Sign In
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer-modern">
//         <div className="container">
//           <div className="footer-content-modern">
//             <div className="footer-brand">
//               <img src={HERO_IMAGE} alt="On-Screen" className="footer-logo" />
//               <p className="footer-tagline">Social Media Management, Simplified</p>
//             </div>
            
//             <div className="footer-links-modern">
//               <div className="footer-column">
//                 <h4>Product</h4>
//                 <a href="/login">Sign In</a>
//                 <a href="/owneradd">Sign Up</a>
//                 <a href="https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g" target="_blank" rel="noopener noreferrer">Documentation</a>
//               </div>
              
//               <div className="footer-column">
//                 <h4>Legal</h4>
//                 <a href="/termsofuse">Terms of Use</a>
//                 <a href="/privacypolicy">Privacy Policy</a>
//               </div>
              
//               <div className="footer-column">
//                 <h4>Support</h4>
//                 <a href="/sendemail">Contact Us</a>
//               </div>
//             </div>
            
//             <div className="footer-company">
//               <img src={SE3D_MARK} alt="SE3D Inc." className="company-logo" />
//               <div className="company-text">
//                 <div className="company-name">SE3D Inc.</div>
//                 <div className="company-tagline">Building the future of social media management</div>
//               </div>
//             </div>
//           </div>
          
//           <div className="footer-bottom">
//             <p>© 2025 On-Screen. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// }

// export default Download;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Download.css';

/**
 * Download Landing Page Component - Modern Redesign
 * 
 * Dribbble-inspired landing page with:
 * - Bold, modern typography
 * - Vibrant gradient backgrounds
 * - Clean card layouts
 * - Professional animations
 * - Clear call-to-actions
 * 
 * Color scheme:
 * - Primary Orange: #ff6800
 * - Primary Blue: #01057a
 * - Gray: #3C3C3C
 */
function Download() {
  const navigate = useNavigate();
  
  // State for PWA installation
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [platform, setPlatform] = useState('unknown');
  const [showIOSInstructions, setShowIOSInstructions] = useState(false);
  
  // Asset paths
  const HERO_IMAGE = '/images/on-screen-logo.png';
  const APP_ICON_192 = '/on-screen-logo-192x192.png';
  const SE3D_MARK = '/images/se3d-inc-mark-64.png';
  
  useEffect(() => {
    detectPlatform();
    checkIfInstalled();
    
    const handleBeforeInstallPrompt = (e) => {
      console.log('📱 PWA install prompt available');
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    
    const handleAppInstalled = () => {
      console.log('✅ PWA was installed');
      setIsInstalled(true);
      setIsInstallable(false);
      setDeferredPrompt(null);
    };
    
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);
  
  const detectPlatform = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('ios');
      return;
    }
    
    if (/android/i.test(userAgent)) {
      setPlatform('android');
      return;
    }
    
    if (!/Mobi|Android/i.test(userAgent)) {
      setPlatform('desktop');
      return;
    }
    
    setPlatform('unknown');
  };
  
  const checkIfInstalled = () => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isIOSStandalone = window.navigator.standalone === true;
    
    if (isStandalone || (isIOS && isIOSStandalone)) {
      setIsInstalled(true);
      console.log('✅ App is running as installed PWA');
    }
  };
  
  const handleInstall = async () => {
    if (!deferredPrompt) {
      console.log('ℹ️ No install prompt available');
      
      if (platform === 'ios') {
        setShowIOSInstructions(true);
      }
      return;
    }
    
    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      console.log(`👤 User response to install prompt: ${outcome}`);
      
      if (outcome === 'accepted') {
        console.log('✅ User accepted the install prompt');
        setIsInstalled(true);
      } else {
        console.log('❌ User dismissed the install prompt');
      }
      
      setDeferredPrompt(null);
      setIsInstallable(false);
      
    } catch (error) {
      console.error('❌ Error during PWA installation:', error);
    }
  };
  
  const handleGetStarted = () => {
    navigate('/login');
  };
  
  const handleOwnerSignup = () => {
    navigate('/owneradd');
  };
  
  const scrollToInstall = () => {
    document.getElementById('install-section')?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'center'
    });
  };
  
  const renderInstallInstructions = () => {
    if (isInstalled) {
      return (
        <div className="install-card success">
          <div className="install-icon-wrapper success">
            <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3>You're All Set! 🎉</h3>
          <p>On-Screen is installed and ready to use.</p>
          <button className="cta-button primary" onClick={handleGetStarted}>
            Launch App
          </button>
        </div>
      );
    }
    
    if (isInstallable && platform !== 'ios') {
      return (
        <div className="install-card">
          <div className="install-icon-wrapper">
            <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </div>
          <h3>Install On-Screen</h3>
          <p>Get the best experience with our PWA</p>
          <button className="cta-button primary" onClick={handleInstall}>
            Install Now
          </button>
          <button className="cta-button secondary" onClick={handleGetStarted}>
            Continue in Browser
          </button>
        </div>
      );
    }
    
    if (platform === 'ios') {
      return (
        <div className="install-card">
          <div className="install-icon-wrapper">
            <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <h3>Install on iOS</h3>
          <button 
            className="cta-button primary" 
            onClick={() => setShowIOSInstructions(!showIOSInstructions)}
          >
            View Instructions
          </button>
          
          {showIOSInstructions && (
            <div className="ios-instructions">
              <ol>
                <li>Tap the <strong>Share</strong> button in Safari</li>
                <li>Scroll and tap <strong>"Add to Home Screen"</strong></li>
                <li>Tap <strong>"Add"</strong></li>
              </ol>
            </div>
          )}
          
          <button className="cta-button secondary" onClick={handleGetStarted}>
            Continue in Browser
          </button>
        </div>
      );
    }
    
    return (
      <div className="install-card">
        <div className="install-icon-wrapper">
          <svg className="install-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
          </svg>
        </div>
        <h3>Get Started</h3>
        <p>Look for "Install" in your browser menu</p>
        <button className="cta-button primary" onClick={handleGetStarted}>
          Continue in Browser
        </button>
      </div>
    );
  };

  // Features with professional icons
  const features = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Smart Scheduling',
      description: 'Plan and schedule your content across all platforms with our intuitive calendar',
      color: 'orange'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
        </svg>
      ),
      title: 'Event Management',
      description: 'Create and manage events, auctions, and raffles with ease',
      color: 'blue'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
      title: 'Multi-Platform',
      description: 'Connect Instagram, Facebook, Twitter, LinkedIn, TikTok, YouTube & more',
      color: 'orange'
    },
    // {
    //   icon: (
    //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    //     </svg>
    //   ),
    //   title: 'Analytics',
    //   description: 'Track performance and engagement with detailed insights (coming soon)',
    //   color: 'blue'
    // },
    // {
    //   icon: (
    //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    //     </svg>
    //   ),
    //   title: 'Media Editor',
    //   description: 'Edit images and videos right in the app (coming soon)',
    //   color: 'orange'
    // },
    // {
    //   icon: (
    //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    //     </svg>
    //   ),
    //   title: 'Notifications',
    //   description: 'Stay updated with real-time push notifications (coming soon)',
    //   color: 'blue'
    // },
  ];

  // Quick links with icons
  const quickLinks = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
        </svg>
      ),
      title: 'Create Account',
      description: 'Sign up and create your tenant',
      action: () => navigate('/owneradd'),
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
        </svg>
      ),
      title: 'Sign In',
      description: 'Access your account',
      action: () => navigate('/login'),
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      title: 'Documentation',
      description: 'Learn how to use On-Screen',
      action: () => window.open('https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g', '_blank'),
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Install App',
      description: 'Get the PWA experience',
      action: scrollToInstall,
    },
  ];

  return (
    <div className="download-page modern">
      {/* Hero Section */}
      <section className="hero-modern">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
        
        <div className="container">
          <div className="hero-content-modern">
            <div className="hero-text-modern">
              <div className="badge">Social Media Management</div>
              <h1 className="hero-title-modern">
                Simplify Your <span className="gradient-text">Social Media</span> Workflow
              </h1>
              <p className="hero-description-modern">
                Schedule posts, manage events, and grow your presence across all platforms. 
                One powerful app for all your social media needs.
              </p>
              
              <div className="hero-cta-buttons">
                <button className="cta-button primary large" onClick={handleGetStarted}>
                  Get Started Free
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </button>
                <button className="cta-button secondary large" onClick={() => window.open('https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g', '_blank')}>
                  View Documentation
                </button>
              </div>
              
              <div className="social-proof">
                <div className="proof-item">
                  <div className="proof-number">1000+</div>
                  <div className="proof-label">Active Users</div>
                </div>
                <div className="proof-divider"></div>
                <div className="proof-item">
                  <div className="proof-number">7</div>
                  <div className="proof-label">Platforms</div>
                </div>
                <div className="proof-divider"></div>
                <div className="proof-item">
                  <div className="proof-number">99%</div>
                  <div className="proof-label">Uptime</div>
                </div>
              </div>
            </div>
            
            <div className="hero-visual">
              <div className="visual-card floating">
                <img src={HERO_IMAGE} alt="On-Screen" className="hero-logo-modern" />
              </div>
              <div className="floating-element el-1"></div>
              <div className="floating-element el-2"></div>
              <div className="floating-element el-3"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Install Section */}
      <section className="install-section-modern" id="install-section">
        <div className="container">
          <div className="install-content">
            {renderInstallInstructions()}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-modern">
        <div className="container">
          <div className="section-header">
            <div className="badge">Features</div>
            <h2 className="section-title-modern">Everything You Need</h2>
            <p className="section-description-modern">
              Powerful tools to manage your social media presence efficiently
            </p>
          </div>
          
          <div className="features-grid-modern">
            {features.map((feature, index) => (
              <div key={index} className={`feature-card-modern ${feature.color}`}>
                <div className="feature-icon-modern">
                  {feature.icon}
                </div>
                <h3 className="feature-title-modern">{feature.title}</h3>
                <p className="feature-description-modern">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className="quick-links-modern">
        <div className="container">
          <div className="section-header">
            <div className="badge">Get Started</div>
            <h2 className="section-title-modern">Quick Access</h2>
            <p className="section-description-modern">
              Everything you need to get up and running
            </p>
          </div>
          
          <div className="quick-links-grid">
            {quickLinks.map((link, index) => (
              <button
                key={index}
                className="quick-link-card"
                onClick={link.action}
              >
                <div className="quick-link-icon">
                  {link.icon}
                </div>
                <h3 className="quick-link-title">{link.title}</h3>
                <p className="quick-link-description">{link.description}</p>
                <div className="quick-link-arrow">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-modern">
        <div className="cta-gradient"></div>
        <div className="container">
          <div className="cta-content-modern">
            <h2 className="cta-title-modern">Ready to Transform Your Social Media?</h2>
            <p className="cta-description-modern">
              Join thousands of users who are already managing their social media presence with On-Screen
            </p>
            <div className="cta-buttons-modern">
              {!isInstalled && isInstallable && (
                <button className="cta-button primary large" onClick={handleInstall}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Install App
                </button>
              )}
              <button className="cta-button primary large" onClick={handleOwnerSignup}>
                Sign Up Free
              </button>
              <button className="cta-button secondary large" onClick={handleGetStarted}>
                Sign In
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer-modern">
        <div className="container">
          <div className="footer-content-modern">
            <div className="footer-column">
              <h4>Product</h4>
              <a href="/login">Sign In</a>
              <a href="/owneradd">Sign Up</a>
              <a href="https://scribehow.com/viewer/Create_Account_Login_Post_Content_and_Manage_Tasks__peI0qKp-TrSDsQXYQFeW1g" target="_blank" rel="noopener noreferrer">Documentation</a>
            </div>
            
            <div className="footer-column">
              <h4>Legal</h4>
              <a href="/termsofuse">Terms of Use</a>
              <a href="/privacypolicy">Privacy Policy</a>
            </div>
            
            <div className="footer-column">
              <h4>Support</h4>
              <a href="/sendemail">Contact Us</a>
            </div>
          </div>
          
          <div className="footer-company">
            <img src={SE3D_MARK} alt="SE3D Inc." className="company-logo" />
            <div className="company-text">
              <div className="company-name">SE3D Inc.</div>
              <div className="company-tagline">Building the future of social media management</div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>© 2025 On-Screen. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Download;